export default function R_DataTypes() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_DataTypes Component</h1>
      <p>This is the R_DataTypes tutorial section.</p>
    </div>
  );
}
